
import React from 'react';
import {Img} from 'views/AppElements';
import {Separator} from 'views/AppElements';

import AppUtil from 'AppUtil';

import {PaymentConfirmationDM} from 'pages/CheckoutPage';

const QRCodeForm = ({amount}) => {

    return (
        <div id="qrCodeForm" className="paymentForm">
            <ul>
                <li>Scan the QR Code below using <b>eSewa</b>/<b>IME Pay</b> or any <b>Mobile Banking</b> application.</li>
                {
                    (amount !== null && amount !== undefined && amount > 0) &&
                    <li>Enter Amount: <b>{"Rs. "+AppUtil.formatNumber(amount)}</b></li>
                }
                
                <li>Enter Remarks: <b>Your Name</b> <i><small>(same as in your order)</small></i>.</li>

                <li>After finishing your payment, DM Us it's screenshot and our operator shall confirm and update your order. You can send the screenshot in:</li>
                
                <PaymentConfirmationDM />
                
            </ul>

            <Separator />
            <Img className="qrCodeImg" src="/images/merchant_qr_code.jpg" title="Seto Canvas Merchant QR Code for payment"
                style={{maxWidth: '100%'}}/>

            
        </div>
        
    
    );
};


export default QRCodeForm;


// WEBPACK FOOTER //
// ./src/views/QRCodeForm.js